import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SessionModel } from '../interface/session-model';
import { DatasharingService } from '../service/datasharing.service';
import { AppconfigService } from '../service/appconfig.service';
import { GlobalService } from '../service/global.service';


@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent implements OnInit {

  errormsg: string = "";
  showLoginLink: boolean = false;
  SessionList: SessionModel = new SessionModel();
  errorCode: any;
  query_param: any;

  constructor(private route: ActivatedRoute, private router: Router, 
    private datasharing: DatasharingService , private configService: AppconfigService,
    private globeService: GlobalService) {

  }
  
  
 

  ngOnInit() {

    console.log('ngOnInit of error')

    var showLoginLinkB = true;
    this.query_param = this.route.snapshot.queryParams["msgCd"];

    console.log('query_param ', this.query_param)

    if (this.query_param == "URM401") {
          this.errormsg = this.configService.config.URM401;
          showLoginLinkB = false;
    }
    else
    {
      this.errorCode = this.SessionList.errorCode;
      if( this.errorCode != undefined && this.errorCode == "URMERR1016")
      {
        showLoginLinkB = false;
      }
      else if(this.SessionList.errorMsg != undefined && this.SessionList.errorCode == undefined)
      {
        this.errormsg = this.SessionList.errorMsg;
        showLoginLinkB = true;
      }
      else
      {
        showLoginLinkB = true;
      }
    } 

    if((this.errorCode == null || this.errorCode == undefined) && 
        (this.errormsg == null || this.errormsg == undefined || this.errormsg ==''))
    {
      this.errormsg = "System error has occurred. Please try again.";
      showLoginLinkB = true;
    }  

    this.showLoginLink = showLoginLinkB;    
    sessionStorage.clear();

  }

  public login()
  {
    this.globeService.login();
  }

  public navigateToHome() {
    this.datasharing.isPowerBiB.next(false);
    this.login();
  }

}
